import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CommissionList from '../components/CommissionList';
import { Form, Button, Alert } from 'react-bootstrap';

const Commissions = () => {
  const [commissions, setCommissions] = useState([]);
  const [formData, setFormData] = useState({ saleId: '', userId: '', amount: 0, status: 'pending' });
  const [error, setError] = useState('');

  const fetchCommissions = async () => {
    try {
      const response = await axios.get('https://venticrm.unsoloclic.mx/api/commissions');
      setCommissions(response.data);
    } catch (err) {
      setError('Error obteniendo comisiones');
    }
  };

  useEffect(() => {
    fetchCommissions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.saleId || !formData.userId || !formData.amount) {
      setError('Todos los campos son obligatorios');
      return;
    }
    try {
      await axios.post('http://localhost:5000/api/commissions', formData);
      fetchCommissions();
      setFormData({ saleId: '', userId: '', amount: 0, status: 'pending' });
      setError('');
    } catch (err) {
      setError('Error registrando comisión');
    }
  };

  return (
    <div className="container mt-4">
      <h1>Comisiones</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>ID de Venta</Form.Label>
          <Form.Control
            type="number"
            value={formData.saleId}
            onChange={(e) => setFormData({ ...formData, saleId: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>ID de Usuario</Form.Label>
          <Form.Control
            type="number"
            value={formData.userId}
            onChange={(e) => setFormData({ ...formData, userId: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Monto</Form.Label>
          <Form.Control
            type="number"
            value={formData.amount}
            onChange={(e) => setFormData({ ...formData, amount: parseFloat(e.target.value) })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Estado</Form.Label>
          <Form.Control
            as="select"
            value={formData.status}
            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
          >
            <option value="pending">Pendiente</option>
            <option value="paid">Pagado</option>
          </Form.Control>
        </Form.Group>
        <Button type="submit" className="mt-3">Registrar Comisión</Button>
      </Form>
      <CommissionList commissions={commissions} fetchCommissions={fetchCommissions} />
    </div>
  );
};

export default Commissions;